module.exports = {"temperatura":{"range":[32,140],"default":[60,100],"step":1.8,"colors":["0x12aee2","0xdd1818"],"unidades":"ºF"},"vegetacion":{"range":[-1,1],"default":[0.3,1],"step":0.05,"colors":["0x0eed88","0x32996a"],"unidades":null},"humedad":{"range":[-1,1],"default":[0,0.5],"step":0.05,"colors":["0xdd1818","0x12aee2"],"unidades":null},"albedo":{"range":[0,0.3],"default":[0,0.3],"step":0.01,"colors":["0x12aee2","0xdd1818"],"unidades":null}}


//////////////////
// WEBPACK FOOTER
// ./src/components/core/utils/indicadores-default-params.json
// module id = 516
// module chunks = 1